import moment from "moment";

// API
import { fetchRegisteredEvents, registerEventAndMarkAttendance } from "@/api";

// Utils
import { deserializeRegisteredEvents } from "@/utils/deserializers/registered-events-deserializer";

// Constants
export const INITIALIZE_REGISTERED_EVENTS = "INITIALIZE_REGISTERED_EVENTS";
export const REGISTERED_EVENTS_LOADING = "REGISTERED_EVENTS_LOADING";
export const MARK_EVENT = "MARK_EVENT";
export const ONLINE = "online";
export const PAN = "Pan";

// Utils
export const initializeRegisteredEvents = (payload) => {
    return {
        type: INITIALIZE_REGISTERED_EVENTS,
        payload,
    };
};
export const markEvents = (payload) => {
    return {
        type: MARK_EVENT,
        payload,
    };
};

export const registeredEventsGetAndStore = (payload) => {
    return (dispatch) => {
        dispatch({ type: REGISTERED_EVENTS_LOADING });
        fetchRegisteredEvents(payload)
            .then((res) => {
                deserializeRegisteredEvents(res.data || []).then((events) =>
                    dispatch(initializeRegisteredEvents(events))
                );
            })
            .catch((err) => {
                console.log(err);
                dispatch(initializeRegisteredEvents({}));
            });
    };
};

export const registerEventFunc = (eventDetails, profileData, callBack) => {
    const slot = eventDetails.slot || eventDetails.dateTimeIsoFormat
        ? moment(eventDetails.dateTimeIsoFormat).format("hh:mm a")
        : "12:00 pm";

    const payload = {
        registrant: {
            ...eventDetails.formPageContant,
            lead_source: "",
            lead_status: "",
            campaign_name: "",
            campaign_type: "",
            campaign_owner: "",
            student_source: "Azent.com",
            first_name: profileData.firstName,
            last_name: profileData.lastName,
            email: profileData.email,
            mobile: profileData.mobile,
            slot,
        },
        utm_params: {
            href: eventDetails.slug,
            slug_href: eventDetails.slug,
        },
    };

    if (eventDetails.eventStartDate) {
        payload.registrant.event_start_date = eventDetails.eventStartDate
    }

    registerEventAndMarkAttendance(payload)
        .then((res) => {
            if (res) {
                callBack && callBack(res, true, eventDetails);
            }
        })
        .catch((err) => {
            console.log("err:", err);
            callBack && callBack(err, false);
        });
};
